(() => {
  const PRODUCT_PAGE = document.body.classList.contains('template-product');
  if (!PRODUCT_PAGE) return;

  const decodeVisibleEntity = (value) =>
    typeof value === 'string' ? value.replaceAll('&amp;', '&') : value;

  const repairQuantityLabels = (root = document) => {
    root
      .querySelectorAll(
        '.quantity__button [class*="visually-hidden"], .quantity__input[aria-label]'
      )
      .forEach((node) => {
        if (node.hasAttribute('aria-label')) {
          const currentLabel = node.getAttribute('aria-label');
          const repairedLabel = decodeVisibleEntity(currentLabel);
          if (repairedLabel !== currentLabel) {
            node.setAttribute('aria-label', repairedLabel);
          }
        } else {
          const repairedText = decodeVisibleEntity(node.textContent);
          if (repairedText !== node.textContent) {
            node.textContent = repairedText;
          }
        }
      });
  };

  const repairJudgeMe = (root = document) => {
    root.querySelectorAll('.jm-media-grid__item[aria-selected]').forEach((item) => {
      item.removeAttribute('aria-selected');
    });

    root.querySelectorAll('.jdgm-widget img, .jm-media-grid__item img').forEach((image) => {
      if (!image.hasAttribute('loading')) image.loading = 'lazy';
      if (!image.hasAttribute('decoding')) image.decoding = 'async';

      const addIntrinsicSize = () => {
        if (!image.hasAttribute('width') && image.naturalWidth) {
          image.width = image.naturalWidth;
        }
        if (!image.hasAttribute('height') && image.naturalHeight) {
          image.height = image.naturalHeight;
        }
      };

      if (image.complete) addIntrinsicSize();
      else image.addEventListener('load', addIntrinsicSize, { once: true });
    });
  };

  const repairLocalizedAlt = (root = document) => {
    const locale = document.documentElement.lang?.split('-')[0] || 'en';
    const localizedAlt = {
      en: 'Argivit Focus Tablet with product packaging',
      ar: 'أرجيفيت فوكس أقراص مع العبوة',
      de: 'Argivit Focus Tablet mit Produktverpackung',
      es: 'Argivit Focus Tablet con su envase',
      fr: 'Argivit Focus Tablet avec son emballage',
      it: 'Argivit Focus Tablet con confezione',
      nl: 'Argivit Focus Tablet met productverpakking',
      sv: 'Argivit Focus Tablet med produktförpackning'
    };

    root.querySelectorAll('img[alt="Support Your Teen’s Growth Years"]').forEach((image) => {
      image.alt = localizedAlt[locale] || localizedAlt.en;
    });
  };

  const reconcileHhsFallback = (root = document) => {
    const fallback = root.querySelector('[data-eterik-hhs-related-fallback]');
    if (!fallback) return;

    const nativeRecommendations = root.querySelector(
      '.complementary-products__container .product-card-wrapper, product-recommendations .product-grid .grid__item'
    );
    fallback.hidden = Boolean(nativeRecommendations);
  };

  const repair = (root = document) => {
    repairQuantityLabels(root);
    repairJudgeMe(root);
    repairLocalizedAlt(root);
    reconcileHhsFallback(document);
  };

  const scheduleRepair = (root = document) => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => repair(root), { timeout: 800 });
    } else {
      window.setTimeout(() => repair(root), 0);
    }
  };

  scheduleRepair();

  let observedMutations = 0;
  const observer = new MutationObserver((mutations) => {
    observedMutations += mutations.length;
    const relevantMutation = mutations.find((mutation) =>
      [...mutation.addedNodes].some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.('.jdgm-widget, product-recommendations, quantity-input') ||
            node.querySelector?.('.jdgm-widget, product-recommendations, quantity-input'))
      )
    );

    if (relevantMutation) scheduleRepair(document);
    if (observedMutations > 120) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 12000);

  const judgeMeAttributeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const target = mutation.target;
      if (
        target instanceof Element &&
        target.matches('.jm-media-grid__item[aria-selected]')
      ) {
        target.removeAttribute('aria-selected');
      }
    });
  });

  judgeMeAttributeObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-selected'],
    subtree: true
  });

  [1000, 2500, 5000, 9000, 15000, 24000].forEach((delay) => {
    window.setTimeout(() => repairJudgeMe(document), delay);
  });

  window.setTimeout(() => judgeMeAttributeObserver.disconnect(), 25000);

  document.addEventListener('shopify:section:load', (event) => scheduleRepair(event.target));
})();
